<template>
  <div class="login-wrapper">
    <loader :loading="loading" />
    <div class="d-flex flex-column flex-lg-row align-items-center mt-5 mt-lg-0">
      <div class="logo me-0 me-lg-5 mb-5 mb-lg-0">
        <h6 class="text-white mb-4">Painel de administração</h6>
        <img src="@/assets/logo-white.svg"/>
      </div>

      <div class="form ms-0 ms-lg-5" v-if="!forgotPassword">
        <div class="errors" v-if="error">
          <p class="alert alert-danger">Usuário ou senha inválidos</p>
        </div>

        <div class="form-floating mb-3">
          <input ref="emailInput" type="email" class="form-control" v-model="payload.email" placeholder="Digite o Email" @keyup.enter="handleEmailEnter">
          <label>Email</label>
        </div>
        <div class="form-floating">
          <input ref="passwordInput" type="password" class="form-control" v-model="payload.password" placeholder="Digite a Senha" @keyup.enter="handleLogin">
          <label>Senha</label>
        </div>

        <a href="#" @click.prevent="forgotPassword = true; $nextTick(() => $refs.forgotEmailInput.focus())"
           class="d-flex align-items-center justify-content-center mb-4 mt-4 login-link font-size-default">
          Esqueceu sua senha?
        </a>

        <button class="btn btn-primary btn-block mt-3" @click="handleLogin">Entrar</button>
      </div>

      <div class="form ms-0 ms-lg-5" v-if="forgotPassword">
        <h2 class="title mb-4">Redefinir senha</h2>

        <div class="form-floating mb-3">
          <input
            ref="forgotEmailInput"
            type="email"
            class="form-control"
            :class="{ 'is-invalid': $v.payload.email.$error }"
            v-model.trim="$v.payload.email.$model"
            placeholder="Digite o Email"
            @keyup.enter="resetPassword"
          >
          <label>Email</label>
          <div class="invalid-feedback">Informe um e-mail válido</div>
        </div>

        <a href="#" @click.prevent="forgotPassword = false"
           class="d-flex align-items-center justify-content-center mb-4 mt-4 login-link font-size-default">
          Voltar para o login
        </a>

        <button class="btn btn-primary btn-block mt-3" @click="resetPassword">Enviar link de redefinição</button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import Loader from "@/components/shared/loader.vue";
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: 'login',
  components: {Loader},
  props: {},
  data() {
    return {
      loading: false,
      error: false,
      forgotPassword: false,
      payload: {
        email: null,
        password: null
      }
    }
  },
  validations: {
    payload: {
      email: { required, email }
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.emailInput.focus());
  },
  methods: {
    ...mapActions('auth', ['login']),
    handleEmailEnter() {
      if (this.payload.password) {
        this.handleLogin();
      } else {
        this.$refs.passwordInput.focus();
      }
    },
    async handleLogin() {
      this.loading = true;
      this.error = false;
      await this.login(this.payload).then(response => {
      }).catch(e => {
        this.error = true;
      }).finally(() => {
        this.loading = false;
      })
    },
    async resetPassword() {
      this.$v.payload.email.$touch();

      if (this.$v.payload.email.$invalid) {
        return false;
      }

      this.loading = true;
      await axios.post('/admin/auth/forgot-password', {
        email: this.payload.email,
        redirect_url: window.location.origin + '/redefinir-senha'
      }).then(() => {
        this.$swal.fire({
          icon: 'success',
          html: 'Um link de redefinição de senha foi enviado para o seu e-mail.',
        });
        this.forgotPassword = false;
      }).catch(() => {
        this.$swal.fire({
          icon: 'error',
          html: 'Não foi possível enviar o link. Verifique o e-mail informado ou tente novamente.',
        });
        this.forgotPassword = false;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  height: calc((var(--vh, 1vh) * 100));
  width: 100vw;
  background: var(--primary);
  padding: 1rem;

  @media (min-width: 992px) {
    align-items: center;
  }
}
.logo {
  img {
    width: 220px;

    @media (min-width: 992px) {
      width: 300px;
    }
  }
}

.form {
  background: var(--white);
  border-radius: .32rem;
  padding: 2rem;
  width: 90vw;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, .2);

  @media (min-width: 992px) {
    max-width: 360px;
  }

  .btn {
    height: 55px;
    margin-bottom: 0.5rem !important;
    font-weight: 700 !important;
    font-size: 1rem;
  }

  .login-link {
    color: #666;

    &:hover {
      color: var(--default-text-color);
    }
  }
}

.title {
  font-size: 22px;
  font-weight: 700;
}
</style>
